import EImza from "src/parts/e-imza/EImza";
import { useLazyEImzaLoginQuery } from "src/services/Auth/AuthApi";
import { useAppDispatch, useAppSelector } from "src/store";
import AuthSlice from "src/store/slices/Auth/AuthSlice";

const EImzaLogin = (): JSX.Element => {
    const [finalize, finalizeState] = useLazyEImzaLoginQuery();
    const dispatch = useAppDispatch();
    const userLogin = useAppSelector(s => s.userLogin)

    return (
        <EImza
            tur="cades"
            error={finalizeState.isError}
            helperText={finalizeState.error?.message}
            loading={finalizeState.isFetching}
            onSignInitialize={() => {
                return new Promise((resolve, reject) => {
                    resolve("İşbu sözleşme e-imza ile geçerli bir oturum başlattığımı ve şahsıma ait bir e imza ile bu metni imzaladığımı taahhüt ederim.")
                })
            }}
            onSignFinalize={(sign) => {
                finalize({
                    signatureBase64: sign.signatureBase64,
                    transactionUUID: sign.transactionUUID
                })
                    .unwrap()
                    .then(res => {
                        dispatch(AuthSlice.actions.setState({
                            ...userLogin,
                            isButtonDisabled: true,
                            userInfo: res,
                            isLoggedIn: res.kullaniciId > 0,
                            captchaKodu: "",
                            hataSayi: 0,
                            captchaHelpertext: "",
                            captchaId: null
                        }))
                    })
            }}
        />
    )
}
export default EImzaLogin;